import { muiTheme } from "@/styles/theme";
import { Box, FormControl, MenuItem, Select, Tab, Tabs } from "@mui/material";
import WithResponsiveRendering from "../wrappers/with-responsive-rendering";
import { useContext } from "react";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { Permission } from "@/modules/common/types";
export interface Tab {
  value: number;
  label: string;
  includePermissions?: Permission[];
}

interface ResponsiveTabsProps {
  selectedTab: number;
  handleChange: (value: number) => void;
  tabs: Tab[];
}

const hasRequiredPermissions = (
  tabPermissions: Permission[] | undefined,
  userPermissions: Permission[] | undefined
): boolean => {
  if (!tabPermissions) return true;
  return tabPermissions.some((permission) =>
    userPermissions?.some(
      (p) => p.name === permission.name && p.level === permission.level
    )
  );
};

const ResponsiveTabs = WithResponsiveRendering({
  MobileComponent: MobileSelect,
  DesktopComponent: DesktopTabs,
});

function MobileSelect({
  tabs,
  selectedTab,
  handleChange,
}: ResponsiveTabsProps) {
  const { permissions } = useContext(NawyPassportContext);
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl
        variant="standard"
        sx={{
          marginTop: 1,
          width: "100%",
        }}
      >
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={selectedTab}
          onChange={(e) => handleChange(+e.target.value)}
          size="small"
          sx={{
            color: "#015C9A",
            fontSize: "14px",
            width: "100%",
            backgroundColor:
              muiTheme.colorSchemes.light.palette.main.actionDisabled,
            paddingX: 2,
            paddingY: 1,
          }}
        >
          {tabs.map(({ value, label, includePermissions }) =>
            hasRequiredPermissions(includePermissions, permissions) ? (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ) : null
          )}
        </Select>
      </FormControl>
    </Box>
  );
}

function DesktopTabs({ tabs, selectedTab, handleChange }: ResponsiveTabsProps) {
  return (
    <Tabs
      value={selectedTab}
      onChange={(_, value) => handleChange(value)}
      textColor="inherit"
      indicatorColor="primary"
      aria-label="secondary tabs example"
      sx={{
        ...muiTheme.typography.body_md_med,
        textTransform: "none",
        color: muiTheme.colorSchemes.light.palette.main.actionHover,
      }}
    >
      {tabs.map((tab) => {
        return (
          /*hasRequiredPermissions(tab.includePermissions, permissions) ? */ <Tab
                      key={tab.value}
                      sx={{ fontSize: "h3_reg", textTransform: "none" }}
                      label={tab.label}
                      value={tab.value}
                    />
        ); /*: null;*/
      })}
    </Tabs>
  );
}

export default ResponsiveTabs;
